// env
export const ENV = process.env.NEXT_PUBLIC_ENV;
export const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV || 'development';

// urls
export const API_URL =
  process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';
export const CDN_URL =
  process.env.NEXT_PUBLIC_CDN_URL ||
  'https://storage.googleapis.com/beek-web-cdn';
export const IMAGE_CDN_URL =
  process.env.NEXT_PUBLIC_IMAGE_CDN_URL || 'https://nicephore.beek.io';
export const GRAPHQL_CORE_URL =
  process.env.NEXT_PUBLIC_GRAPHQL_CORE_URL ||
  'https://core.beek.io/graphql_public';
export const GRAPHQL_API_URL =
  process.env.NEXT_PUBLIC_GRAPHQL_API_URL || 'http://localhost:3000/graphql';
export const WEB_PLAYER_URL =
  process.env.NEXT_PUBLIC_WEB_PLAYER_URL || 'https://play.beek.io';
export const ONELINK_URL =
  process.env.NEXT_PUBLIC_ONELINK_URL ||
  'https://beek.onelink.me/uzWC/1z6wn3f1';

// Cookies
export const AUDIOBOOK_ID_COOKIE_NAME =
  process.env.NEXT_PUBLIC_AUDIOBOOK_ID_COOKIE_NAME || `${APP_ENV}_audiobook_id`;
export const AUTH_TOKEN_COOKIE_NAME =
  process.env.NEXT_PUBLIC_AUTH_TOKEN_COOKIE_NAME || `${APP_ENV}_user_token`;
export const USER_ROLE_COOKIE_NAME =
  process.env.NEXT_PUBLIC_USER_ROLE_COOKIE_NAME || `${APP_ENV}_user_role`;
export const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;
export const LOGIN_TOKEN_SUCCEED_COOKIE_NAME =
  process.env.NEXT_PUBLIC_LOGIN_TOKEN_SUCCEED_COOKIE_NAME ||
  `${APP_ENV}_login_token_succeed`;
export const CHALLENGE_ID_COOKIE_NAME =
  process.env.NEXT_PUBLIC_CHALLENGE_ID_COOKIE_NAME || `${APP_ENV}_challenge_id`;

// Facebook
export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID;
export const FACEBOOK_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

// GTM
export const GTM_CONTAINER_KEY_BEEK =
  process.env.NEXT_PUBLIC_GTM_CONTAINER_KEY_BEEK;

// Algolia
export const ALGOLIA_API_KEY = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY;
export const ALGOLIA_APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID;
export const ALGOLIA_INDEX_NAME = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME;

// Bayonet
export const BAYONET_DEVICE_FINGERPRINT_API_KEY =
  process.env.NEXT_PUBLIC_BAYONET_DEVICE_FINGERPRINT_API_KEY;

// Branch
export const BRANCH_KEY = process.env.NEXT_PUBLIC_BRANCH_KEY;

// Crypto
export const CRYPTO_IV_KEY = process.env.NEXT_PUBLIC_CRYPTO_IV_KEY;
export const CRYPTO_KEY = process.env.NEXT_PUBLIC_CRYPTO_KEY;

// Stripe
export const STRIPE_PUBLISHABLE_KEY =
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;

export const isProduction = (): boolean => APP_ENV === 'production';

// Experiments
export const EXPERIMENT_PREFIX = process.env.NEXT_PUBLIC_EXPERIMENT_PREFIX_KEY;
